import React from 'react'
import PropTypes from 'prop-types'
import { Text, Icon } from 'components'
import Arrow from './Arrow'
import styles from './PartnershipTable.module.scss'

const PartnershipTable = ({
  partners,
  sortData,
  selectPartner,
  resultsLength,
}) => {
  return (
    <section className={styles.partnershipMain}>
      <section className={styles.resultInfo}>
        {`${resultsLength} parceiros encontrados para a busca`}
      </section>
      <div className={styles.header}>
        <Text className={styles.type} fontSize="small" color="lightBlueColor">
          Tipo
        </Text>
        <div className={styles.name}>
          <Text fontSize="small" color="lightBlueColor">
            Nome do prestador
          </Text>
          <Arrow onClick={() => sortData('name')} arrowDirection="down" />
        </div>
        <div className={styles.city}>
          <Text fontSize="small" color="lightBlueColor">
            Cidade
          </Text>
          <Arrow onClick={() => sortData('city')} arrowDirection="down" />
        </div>
        <div className={styles.state}>
          <Text fontSize="small" color="lightBlueColor">
            Estado
          </Text>
          <Arrow onClick={() => sortData('state')} arrowDirection="down" />
        </div>
        <div className={styles.actions}>
          <Text fontSize="small" color="lightBlueColor">
            Ações
          </Text>
        </div>
      </div>
      <hr className={styles.horizontalLine} />
      <div className={styles.results}>
        {partners.map((partner, index) => (
          <div key={index.toString()} className={styles.row}>
            <div className={styles.type}>
              <div className={styles.icon}>
                <Icon type={partner.type} size={24} color="primaryColor" />
              </div>
            </div>
            <Text
              className={styles.name}
              fontSize="medium"
              color="darkBlueColor"
            >
              {partner.name}
            </Text>
            <Text
              className={styles.city}
              fontSize="medium"
              color="darkBlueColor"
            >
              {partner.city}
            </Text>
            <Text
              className={styles.state}
              fontSize="medium"
              color="darkBlueColor"
            >
              {partner.state}
            </Text>
            <button
              type="button"
              onClick={() => selectPartner(partner.partnerId)}
            >
              <Text
                className={styles.actions}
                fontSize="medium"
                color="primaryColor"
              >
                Mais detalhes
              </Text>
            </button>
          </div>
        ))}
      </div>
    </section>
  )
}

PartnershipTable.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortData: PropTypes.func.isRequired,
  selectPartner: PropTypes.func.isRequired,
  resultsLength: PropTypes.number.isRequired,
}

export default React.memo(PartnershipTable)
